/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const CREATE_URL = "/api/profile/create";
export const DELETE_SAVED_BANK_ACCOUNT_URL = "/api/profile/bank/delete";
export const RETRIEVE_URL = "/api/profile";
export const UPDATE_URL = "/api/profile/update";
export function create(model) {
    return apiService.post(CREATE_URL, true, {
        model
    });
}
export function deleteSavedBankAccount(id) {
    return apiService.post(DELETE_SAVED_BANK_ACCOUNT_URL, true, {
        id
    });
}
export function retrieve() {
    return apiService.post(RETRIEVE_URL, true, {});
}
export function update(updateCommands) {
    return apiService.post(UPDATE_URL, true, {
        updateCommands
    });
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/profile.ts